import PatientOverviewPASummary from 'dashboard/templates/views/Patient/PA/PatientOverviewPASummary';

export default {
  path: 'summary',
  component: PatientOverviewPASummary,
  name: 'PatientRecordPASummary',
  meta: {
    // title: 'Patient Record - Physical Activity - Summary',
    title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('pa.summary')}`,
    loggedInOnly: true,
  },
};
